import React from 'react';
import { useTranslation } from 'react-i18next';
import { Footer } from '@/components/Footer/Footer';
import { TabBar } from '@/components/TabBar/TabBar';
import { PageTopControls } from '@/components/PageTopControls/PageTopControls';
import { SearchBaseResults } from '@/components/SearchBaseResults/SearchBaseResults';
import { VipAdsWithInfiniteScroll } from '@/components/AdsWithInfiniteScroll/VipAdsWithInfiniteScroll';
import { useCurrentCategory } from '@/hooks/useCurrentCategory/useCurrentCategory';
import { useBanner } from '@/hooks/useBanner';
import { VipAndLatestAds } from '@/components/AdsWithInfiniteScroll/VipAndLatestAds';
import { UserAdsWithInfiniteScroll } from '@/components/AdsWithInfiniteScroll/UserAdsWithInfiniteScroll';

export const AdsView = () => {
  const { t } = useTranslation();

  const {
    isVipAds,
    isAllCategories,
    isFirstLevel,
    isSubcategories,
    currentCategory,
    isUserAds,
  } = useCurrentCategory();

  const { topBanner } = useBanner();

  function getHeaderTitle() {
    if (isVipAds) {
      return t('pages.ads.all_vip_ads');
    }

    if (isFirstLevel || isSubcategories) {
      return currentCategory?.name;
    }

    return t('pages.ads.all_categories');
  }

  function renderAdsList() {
    switch (true) {
      case isVipAds: {
        return <VipAdsWithInfiniteScroll />;
      }
      case isUserAds: {
        return <UserAdsWithInfiniteScroll />;
      }
      default: {
        return <VipAndLatestAds />;
      }
    }
  }

  return (
    <>
      {topBanner}

      <PageTopControls
        headerTitle={getHeaderTitle()}
        hasSearch
        hasFilters
        hasCategories={isAllCategories && !isVipAds}
        hasSubcategories={(isFirstLevel || isSubcategories) && !isVipAds}
      />

      {!isVipAds && <SearchBaseResults />}

      {renderAdsList()}

      <Footer />

      <TabBar />
    </>
  );
};
